<template>
  <div
    style="display: flex; flex-direction: column; align-items: center; min-height: 500px; justify-content: center"
  >
    <img src="../assets/Thanks.png" style="margin-bottom: 20px;" class="thanks-image mt-5"/>
    <h2 class="thanks-font mt-5">THANK</h2>
    <h2 class="thanks-font mb-5">YOU!</h2>
    <div style="    font-size: 18px;" class="mb-5">
      {{ msg }}
    </div>
    <u-btn-outlined class="mb-5" v-if="isSub" @click.native.prevent="Goto({name: 'library'})">Go back to library</u-btn-outlined>
    <u-btn-outlined class="mb-5" v-if="!isSub" @click.native.prevent="Goto({name: 'workshops'})">Checkout our Workshops</u-btn-outlined>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    if (from.name == "library" || from.name == "workshop" || (from.name && from.name.includes("lesson"))){
      window.localStorage.setItem("msg", "sub")
      next()
    } else {
      window.localStorage.setItem("msg", "nil")
      next()
    }
  },
  data() {
    return {
      isSub: false,
      msg: "",
      step: "",
      options: {
        headers: [
          {
            title: "Terms & Condition",
            subtitle:
              "By clicking accept you agree to the terms and conditions",
            img: require("../assets/images/registration-07.png")
          }
        ]
      }
    };
  },
  methods: {},
  created() {
    window.fbq("track", "CompleteRegistration");
    let msg = window.localStorage.getItem("msg")
    if (msg && msg == "sub") {
      window.fbq('track', 'Purchase', {    value: 3000,  })
      this.msg = "Your payment has been received. Your subscription for Upskill Library has successfully started."
      this.isSub = true
    } else {
      this.msg = "Thank you for learning with Upskill."
      this.isSub = false
    }
    this.Loaded();
  }
};
</script>

<style scoped>
.thanks-image {
  margin: 0 auto;
  max-width: 200px;
}
.thanks-font {
  font: normal normal normal 120px/100px Montserrat;
  letter-spacing: -3px;
  color: #85EF47;
  opacity: 1;
}

</style>
